// Day 2.5 -- "Martian Soft Intelligence" visual system.
//
// Generalizes the local `LiveKpi` pattern found duplicated per-page
// (AIDiscoveryCommandCenterPage.js and similar) into one shared
// component. Behaviorally identical to every existing local copy it
// replaces: a null/undefined value renders literally as "UNKNOWN", never
// a blank, a zero, or a spinner standing in for missing data. This rule
// is not configurable -- callers that want a genuinely different
// truth-state label pass their own children instead of using this
// component, they do not get a prop to override this string.
import { SurfaceCard } from "./SurfaceCard";
import { StatusBadge } from "./Badges";

export function Metric({ label, value, sublabel, status, tone = "flat", testId }) {
  const isUnknown = value === null || value === undefined;
  return (
    <SurfaceCard tone={tone} className="p-4" data-testid={testId || (label ? `metric-${String(label).toLowerCase().replace(/\s+/g, "-")}` : undefined)}>
      {label && <p className="text-[var(--text-2xs)] font-mono uppercase tracking-wide text-[var(--text-tertiary)] mb-2">{label}</p>}
      <p className={`font-display text-[var(--text-2xl)] font-semibold ${isUnknown ? "text-[var(--text-tertiary)]" : "text-[var(--text-primary)]"}`}>
        {isUnknown ? "UNKNOWN" : value}
      </p>
      {sublabel && <p className="text-[var(--text-2xs)] text-[var(--text-secondary)] mt-1">{sublabel}</p>}
      {status && <div className="mt-2"><StatusBadge value={status} /></div>}
    </SurfaceCard>
  );
}
